@if (fullscreen) {
<div class="fullscreen-login">
  <div class="container min-vh-100">
    <div class="row min-vh-100">
      <div class="col-12 col-sm-6 d-flex justify-content-center align-items-center">
        <div class="w-100">
          <ui-fh-svg-images [name]="'loading'"></ui-fh-svg-images>
        </div>
      </div>
      <div class="col-12 col-sm-6 d-flex align-items-center">
        <div class="row px-5">
          <div class="col-12 mb-3">
            <ui-fh-text [type]="'PAGE-TITLE'" [text]="loadingMessage" [class]="'primary-text loading-text-title'"></ui-fh-text>
          </div>
          <div class="col-12" *ngIf="label">
            <ui-fh-text [@labelFade]="label" [type]="'PAGE-DESCRIPTION'" [text]="label" [class]="'loading-text-description'"></ui-fh-text>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-none d-sm-block bottom-bar position-fixed bottom-0 left-0 w-100">
    <ui-fh-svg-images class="d-block" [name]="'waves'"></ui-fh-svg-images>
  </div>
</div>
} @else {
<div *ngIf="!isListLoading" class="container-fluid success p-0" [ngClass]="{ fullscreen: fullscreenShadow }">
  <div class="row success-overlay h-100 d-flex flex-column m-0" [ngClass]="{ 'justify-content-center align-items-center': centered }">
    <ng-container *ngIf="showFavicon">
      <div class="text-center mb-5">
        <ui-fh-image [style.width]="'fit-content'" [width]="'100'" src="./assets/images/favicon/apple-touch-icon.png" alt="Logo Partnership"></ui-fh-image>
      </div>
    </ng-container>
    <div class="col-12 col-sm-10 align-self-center fh-ripple" [ngClass]="{ 'mt-4': fullscreen }">
      <div></div>
      <div></div>
    </div>
    <ng-container *ngIf="label">
      <div class="text-center mt-5">
        <h3 class="labelLoading">{{ label }}</h3>
      </div>
    </ng-container>
  </div>
</div>

<div *ngIf="isListLoading" class="text-center w-100 my-5">
  @if (!isDataLoaded) {
  <i class="{{ icon }} fa-duotone fa-3x fa-spinner-third fa-spin display-4"></i>
  } @else {
  <ui-fh-alert [icon]="icon + ' fa-search'" [text]="'generics.no_results' | translate" [type]="'BASIC'"></ui-fh-alert>
  }
</div>
}
